import JsBarcode from 'jsbarcode';

// Physical label dimensions in inches, always width × height.
export const shelfTagSizes = [
  { id: '2x1.25', label: '2″ × 1¼″', width: 2, height: 1.25 },
  { id: '2.25x1.25', label: '2¼″ × 1¼″', width: 2.25, height: 1.25 },
  { id: '2.4x1.1', label: '2⅖″ × 1⅒″', width: 2.4, height: 1.1 },
  { id: '2.625x1', label: '2⅝″ × 1″', width: 2.625, height: 1 },
  { id: '3x1.25', label: '3″ × 1¼″', width: 3, height: 1.25 },
  { id: '3.5x1.1', label: '3½″ × 1⅒″', width: 3.5, height: 1.1 },
  { id: '3.5x1.4', label: '3½″ × 1⅖″', width: 3.5, height: 1.4 },
  { id: '4x2', label: '4″ × 2″', width: 4, height: 2 },
];
export const defaultShelfTagSize = shelfTagSizes[0].id;
export const maxShelfTagCopies = 500;
export const formatShelfTagPrice = value => Number(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

export function shelfTagBarcode(upc) {
  const value = String(upc ?? '').trim();
  if (!/^\d{8,14}$/.test(value)) throw new Error('This item does not have a usable UPC for shelf tags.');
  const encoded = {};
  // Code 128 preserves the exact catalog UPC, including leading zeroes.
  JsBarcode(encoded, value, { format: 'CODE128', displayValue: false, margin: 0 });
  return { value, modules: encoded.encodings.map(encoding => encoding.data).join('') };
}

export function shelfTagOptions({ product, sizeId, price: suppliedPrice = '', copies }) {
  const size = shelfTagSizes.find(option => option.id === sizeId);
  const errors = {};
  if (!size) errors.size = 'Choose a label size.';
  const countText = String(copies).trim();
  const count = Number(countText);
  if (!/^\d+$/.test(countText) || count < 1 || count > maxShelfTagCopies) errors.copies = `Enter 1–${maxShelfTagCopies} whole copies.`;
  const priceText = String(suppliedPrice ?? '').trim();
  const price = priceText ? Number(priceText) : null;
  if (!priceText) {
    errors.price = 'Enter the price to print on the label.';
  } else if (!/^\d+(?:\.\d{1,2})?$/.test(priceText) || !Number.isFinite(price) || price > 999999.99) {
    errors.price = 'Enter a price from 0 to 999,999.99, with up to 2 decimals.';
  }
  let barcode;
  try { barcode = shelfTagBarcode(product?.upc); } catch (error) { errors.barcode = error.message; }
  return { errors, size, copies: count, price, barcode };
}
